import React, { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import GPSImportWithPresets  from './components/GPSImport';
import PaceInput from './components/PaceInput';
import TimeGraph from './components/TimeGraph';
import ResultTable from './components/ResultTable';
import GsiMap from './components/GsiMap';
import ChangeLogModal from './components/ChangeLogModal';
import AdSenseBlock from './components/AdSenseBlock';
import { AD_SLOTS } from './constants/adSlots';
import { fetchWeather } from "./utils/weather";
import { fetchWeatherForecast } from "./utils/weather";

import { XMLParser } from 'fast-xml-parser';
import { v4 as uuidv4 } from 'uuid';
import isEqual from 'lodash/isEqual';
import './App.css';
import { PuffLoader } from 'react-spinners';
import { smoothElevation } from './utils/elevationUtils';
import Tooltip from './components/Tooltip';
import { Helmet } from 'react-helmet';/*R1.1.2*/
import { Link } from "react-router-dom";

import { useNavigate } from "react-router-dom";

// R1.7.0★ 追加: 外部データのインポート ★
import { GPX_PRESETS } from './constants/gpxPresets';
import aidTemplates from './templates/aidTemplates.json'; // ★ 追加: エイドテンプレートのインポート ★


// R3.0.9 ★ 今月以降の大会リストを自動生成するロジック（国内・海外分離版） ★

// ★ 大会名抽出（末尾の距離を削る）
const extractRaceName = (label) => {
  return label.replace(/\s*\d+(k|K|mi|MI)?$/, "");
};

// ★ 日付パース関数（YYYYMMDD対応）
const parseDate = (yyyymmdd) => {
  const year = yyyymmdd.slice(0, 4);
  const month = yyyymmdd.slice(4, 6);
  const day = yyyymmdd.slice(6, 8);
  return new Date(`${year}-${month}-${day}`);
};

// ★ 表示用フォーマット（MM/DD）
const formatDate = (yyyymmdd) => {
  const month = yyyymmdd.slice(4, 6);
  const day = yyyymmdd.slice(6, 8);
  return `${month}/${day}`;
};

// 今日を YYYYMMDD 形式の文字列で取得
const now = new Date();
const yyyy = now.getFullYear();
const mm = String(now.getMonth() + 1).padStart(2, '0');
const dd = String(now.getDate()).padStart(2, '0');
const todayStr = `${yyyy}${mm}${dd}`;

// ★ 大会名ごとにまとめる（距離違いを統合）共通関数
const groupByRace = (list) => {
  const map = {};
  list.forEach(r => {
    const raceName = extractRaceName(r.label);

    if (!map[raceName]) {
      map[raceName] = {
        date: r.date,
        title: raceName,
        distances: []
      };
    }

    map[raceName].distances.push(`${r.distance}k`);
  });

  return Object.values(map);
};

// 1. 国内の今日以降の大会を抽出・グループ化
const upcomingDomesticRaces = GPX_PRESETS
    .filter(p => p.region === "domestic" && p.date >= todayStr)
    .sort((a, b) => parseDate(a.date) - parseDate(b.date));
const domesticGroupedRaces = groupByRace(upcomingDomesticRaces);

// 2. 海外の今日以降の大会を抽出・グループ化
const upcomingOverseasRaces = GPX_PRESETS
    .filter(p => p.region === "overseas" && p.date >= todayStr)
    .sort((a, b) => parseDate(a.date) - parseDate(b.date));
const overseasGroupedRaces = groupByRace(upcomingOverseasRaces);

// R3.0.9 ★ ここまで



// 天気取得モジュール
const API_KEY = "4170fd960aed423d87047eb797a8dff1"; // OpenWeatherのキー

// 区分が空でない地点だけ天気を取得
const enrichTableDataWithWeather = async (points) => {
  return await Promise.all(
    points.map(async (point) => {
      if (point.区分 && point.latitude && point.longitude && point.arrivalTimestamp) {
        const forecastList = await fetchWeatherForecast(point.latitude, point.longitude, API_KEY);

        // 到着時刻に最も近い予報を選択
        const closest = forecastList.reduce((prev, curr) => {
          return Math.abs(curr.dt * 1000 - point.arrivalTimestamp) <
                 Math.abs(prev.dt * 1000 - point.arrivalTimestamp)
            ? curr
            : prev;
        });

        return {
          ...point,
          weatherIconUrl: `https://openweathermap.org/img/wn/${closest.weather[0].icon}@2x.png`,
          weatherTemp: `${closest.main.temp.toFixed(1)}℃`
        };
      }
      return { ...point, weatherIconUrl: null, weatherTemp: "" };
    })
  );
};



const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);
    const remainingSecondsAfterHours = totalSeconds % 3600;
    const minutes = Math.floor(remainingSecondsAfterHours / 60);
    const seconds = remainingSecondsAfterHours % 60;
    return (
    <span className="math-inline">
        {totalHours.toString().padStart(2, '0')}:
        {minutes.toString().padStart(2, '0')}:
        {seconds.toString().padStart(2, '0')}
    </span>
    );
};

const toRadians = Math.PI / 180;
const R = 6371e3; // 地球の半径 (メートル)

// ★ fast-xml-parser のインスタンスを作成 ★
const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    isArray: (tagName, jPath, isLeaf, isAttribute) => {
        if (tagName === 'trkpt') return true;
        return false;
    }
});

function MainApp() { /*R1.1.0*/
    const [pointsData, setPointsData] = useState([]);
    const [startTime, setStartTime] = useState('');
    const [itraIndex, setItraIndex] = useState(400); // ITRA PI 初期値あり
    const [initialPace, setInitialPace] = useState('06:50');// 無理なく走れるペース 初期値あり
    const [simulationResult, setSimulationResult] = useState([]);
    const [cumulativeDistancesForGraph, setCumulativeDistancesForGraph] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [manualPoints, setManualPoints] = useState([{ id: uuidv4(), distance: '', type: '', name: '' }]);
    const [draftManualPoints, setDraftManualPoints] = useState([{ id: uuidv4(), distance: '', type: '', name: '', restTime: 0, gateTime: '' }]);
    const [appliedManualPoints, setAppliedManualPoints] = useState([]); // ★ 初期値を設定 ★
    const previousPointsDataRef = useRef(null);
    const [manualPointsApplied, setManualPointsApplied] = useState(false);
    const [firstKmArrivalTime, setFirstKmArrivalTime] = useState(null);
    const [gpxFileName, setGpxFileName] = useState(null);
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [gpxFileLoaded, setGpxFileLoaded] = useState(false);
    const [isGPXLoading, setIsGPXLoading] = useState(false);
    const [isApplyButtonFlashing, setIsApplyButtonFlashing] = useState(false); // ★ Applyボタン点滅制御 state // ★ 追加
    const [finishTime, setFinishTime] = useState(''); // ★ 追加: FINISH時間を管理するstate ★
    const handleInitialPaceChange = (e) => setInitialPace(e.target.value);//R1.4.1
    const [isModalOpen, setIsModalOpen] = useState(false);//R2.2.0
    const [selectedPreset, setSelectedPreset] = useState(null);//R2.2.6
    const currentPresetRef = useRef(null);//R2.2.6

    // ファイル選択時にローディングを開始
    const handleFileSelected = useCallback(() => {
        setGpxFileLoaded(false); // ★ ファイル選択時に false に設定 ★
        setPointsData([]);
        setSimulationResult([]);
        setTableData([]);
        setFirstKmArrivalTime(null);
    }, []);

    // GPX読み込み完了後にローディングを終了
    const finishLoading = useCallback(() => {
        setIsGPXLoading(false);
    }, []);

    // グローバルカーソル変更：loading-cursorクラスの付け外し
    useEffect(() => {
        const className = 'loading-cursor';
        const htmlElem = document.documentElement;
        const bodyElem = document.body;
        const rootElem = document.getElementById('root'); // root要素を取得

        // rootElemが存在する場合のみクラスを操作する
        if (rootElem) {
            if (isGPXLoading) {
                htmlElem.classList.add(className);
                bodyElem.classList.add(className);
                rootElem.classList.add(className); // root要素にもクラスを追加
            } else {
                htmlElem.classList.remove(className);
                bodyElem.classList.remove(className);
                rootElem.classList.remove(className); // root要素からもクラスを削除
            }
        }
    }, [isGPXLoading]);

    // 距離計算
    const calculateDistance = useCallback((lat1, lon1, lat2, lon2) => {
        const φ1 = lat1 * toRadians;
        const φ2 = lat2 * toRadians;
        const Δφ = (lat2 - lat1) * toRadians;
        const Δλ = (lon2 - lon1) * toRadians;

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        const distance = R * c;
        return distance / 1000;
    }, []);

    const generateStorageKey = useCallback((gpxFileName) => {
        if (!gpxFileName) return null;
        // より堅牢にするなら、GPXファイルの内容からハッシュ値を生成するなどの処理を追加
        return `${gpxFileName}_manual_points_v2`; // キーをバージョン管理しておくと後々便利
    }, []);

    const loadManualPoints = useCallback((key) => {
        if (key) {
            const storedPoints = localStorage.getItem(key);
            if (storedPoints) {
                try {
                    const parsedPoints = JSON.parse(storedPoints);
                    setManualPoints(parsedPoints);
                    setDraftManualPoints(parsedPoints.map(p => ({ ...p })));
                    setAppliedManualPoints(parsedPoints.map(p => ({ ...p })));
                } catch (error) {
                    console.error("手動地点情報の読み込みエラー:", error);
                }
            } else {
                // 保存された地点情報がない場合は初期状態に戻す
                setManualPoints([{ id: uuidv4(), distance: '', type: '', name: '' }]);
                setDraftManualPoints([{ id: uuidv4(), distance: '', type: '', name: '' }]);
                setAppliedManualPoints([]);
            }
        }
    }, [setManualPoints, setDraftManualPoints, setAppliedManualPoints]);

    const saveManualPoints = useCallback((gpxFileName, currentManualPoints) => {
        const storageKey = generateStorageKey(gpxFileName);
        if (storageKey) {
            try {
                localStorage.setItem(storageKey, JSON.stringify(currentManualPoints));
                setFeedbackMessage('エイド情報を保存しました');
                setTimeout(() => setFeedbackMessage(''), 3000);
            } catch (error) {
                console.error("手動地点情報の保存エラー:", error);
                setFeedbackMessage('保存に失敗しました');
                setTimeout(() => setFeedbackMessage(''), 3000);
            }
        }
    }, [generateStorageKey, setFeedbackMessage]);

    // GPX読み込みハンドラ (fast-xml-parser を使用)
    const handleGPSDataImport = useCallback(async (gpxData, fileName) => {
        // 初期状態のリセット
        setIsGPXLoading(true);
        setGpxFileName(fileName);
        setGpxFileLoaded(false); // パース完了まで false
        setTableData([]);
        setSimulationResult([]);

        const storageKey = generateStorageKey(fileName);
        const storedPoints = localStorage.getItem(storageKey);

        //R2.2.6 START 
        // 1. PRESET は常に検索する（limit のため）
        const normalized = fileName.split('/').pop();
        const normalizedWithExt = normalized.endsWith('.gpx')
            ? normalized
            : normalized + '.gpx';

        const foundPreset = GPX_PRESETS.find(
            p => p.file.endsWith(normalizedWithExt) || p.id === normalized
        );

        // ★ limit 用に必ずセット
        setSelectedPreset(foundPreset || null);

        // 2. manualPoints は storedPoints を優先
        if (storedPoints) {
            loadManualPoints(storageKey);
        } else {
            // PRESET の templateId を使う
            let targetTemplateId = null;

            if (foundPreset && foundPreset.templateId) {
                targetTemplateId = foundPreset.templateId;
            } else {
                const fileSlug = normalized.toLowerCase().replace(/[^a-z0-9]/g, '-');
                targetTemplateId = Object.keys(aidTemplates).find(key => 
                    fileSlug.includes(key.toLowerCase()) || key.toLowerCase().includes(fileSlug)
                );
            }

            if (targetTemplateId && aidTemplates[targetTemplateId]) {
                const template = aidTemplates[targetTemplateId];
                const newPoints = template.map(p => ({ ...p, id: uuidv4() }));
                setManualPoints(newPoints);
                setDraftManualPoints(newPoints.map(p => ({ ...p })));
                setAppliedManualPoints(newPoints.map(p => ({ ...p })));
            } else {
                loadManualPoints(storageKey);
            }
        }
        // R2.2.6 END

        // ★ ここで tableData と simulationResult をリセット ★
        setTableData([]);
        setSimulationResult([]);

        if (gpxData) {
            try {
            const result = parser.parse(gpxData);
            let trackPoints = [];
            const trks = result?.gpx?.trk;
                
            if (Array.isArray(trks)) {
                trks.forEach(trk => {
                const trksegs = trk?.trkseg;
                if (Array.isArray(trksegs)) {
                    trksegs.forEach(trkseg => {
                    if (Array.isArray(trkseg?.trkpt)) {
                        trackPoints = [...trackPoints, ...trkseg.trkpt];
                    } else if (trkseg?.trkpt) {
                        trackPoints.push(trkseg.trkpt);
                    }
                 });
                } else if (trksegs?.trkpt) {
                    if (Array.isArray(trksegs.trkpt)) {
                        trackPoints = [...trackPoints, ...trksegs.trkpt];
                    } else {
                        trackPoints.push(trksegs.trkpt);
                    }
                    }
                });
                } else if (trks) { // trk が単一オブジェクトの場合
                    const trksegs = trks?.trkseg;
                    if (Array.isArray(trksegs)) {
                        trksegs.forEach(trkseg => {
                            if (Array.isArray(trkseg?.trkpt)) {
                                trackPoints = [...trackPoints, ...trkseg.trkpt];
                            } else if (trkseg?.trkpt) {
                                trackPoints.push(trkseg.trkpt);
                            }
                        });
                    } else if (trksegs?.trkpt) {
                        if (Array.isArray(trksegs.trkpt)) {
                            trackPoints = [...trackPoints, ...trksegs.trkpt];
                        } else {
                            trackPoints.push(trksegs.trkpt);
                        }
                    }
                }
                
                if (!Array.isArray(trackPoints) || trackPoints.length === 0) {
                    alert("GPXファイルにトラックポイントが含まれていません。");
                    setIsGPXLoading(false); // データなしの場合もローディング終了
                    return;
                }
                
                // GPXデータの標高をスムージング
                const elevationArray = trackPoints.map(trkpt => parseFloat(trkpt?.ele) || 0);
                const smoothedElevations = smoothElevation(elevationArray, 1); // スムージング適用

                const newPointsData = [];
                let cumulativeDistance = 0;
                let previousPoint = null;

                for (let i = 0; i < trackPoints.length; i++) {
                    const trkpt = trackPoints[i];
                    const latitude = parseFloat(trkpt["@_lat"]); // 属性は @_ プレフィックス付き
                    const longitude = parseFloat(trkpt["@_lon"]);
                    const elevation = smoothedElevations[i]; // スムージング適用後の標高データを使用
                    const time = trkpt?.time;

                    let sectionDistance = 0;
                    let sectionGradient = 0;

                    if (previousPoint) {
                        const distance = calculateDistance(previousPoint.latitude, previousPoint.longitude, latitude, longitude);
                        sectionDistance = distance;
                        cumulativeDistance += distance;
                        if (previousPoint.elevation !== null && elevation !== null && distance > 0) {
                            const elevationChange = elevation - previousPoint.elevation;
                            const distanceInMeters = distance * 1000;
                            sectionGradient = (elevationChange / distanceInMeters) * 100;
                        }
                    }
                    newPointsData.push({
                        id: i,
                        point_type: "GPSトラックポイント",
                        name: `トラックポイント ${i + 1}`,
                        cumulative_distance: cumulativeDistance,
                        section_distance: sectionDistance,
                        elevation: elevation,
                        section_gradient: sectionGradient,
                        surface_type: "推定",
                        arrival_time: time ? new Date(time).toLocaleTimeString() : null,
                        rest_time: undefined,
                        latitude: latitude,
                        longitude: longitude,
                        timestamp: time,
                        区分: '',
                        区分名称: '',
                        manual: false
                    });
                    previousPoint = { latitude, longitude, elevation };
                }

                if (newPointsData.length > 0) {
                    newPointsData[0].cumulative_distance = 0;
                    newPointsData[0].区分 = 'START';
                    if (newPointsData.length > 1) {
                        newPointsData[newPointsData.length - 1].区分 = 'FINISH';
                    }
                }

                setPointsData(newPointsData);
                setGpxFileLoaded(true); // ★ GPXデータ処理完了後に true に設定 ★
                setIsGPXLoading(false); // GPXデータの処理が完了したら、ローディングを終了させる

            } catch (error) {
            console.error("GPXのパースに失敗しました", error);
            alert("GPXファイルの読み込みに失敗しました。");
            } finally {
                setIsGPXLoading(false);

                // 👇 ★ R2.2.2 追加：レース（GPX）読み込み完了後に、入力欄（PaceInput）へ自動スクロール
                setTimeout(() => {
                    const targetElement = document.getElementById('aid-info-area');
                    if (targetElement) {
                        // block: 'center' で画面中央に持ってくることで、最下部固定広告にボタンが被るのを防ぎます
                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 200); // 💡 GPS展開とレンダリングの時間を考慮し、少し余裕を持って200ms待ってから実行します
            }
        } else {
            console.log("GPXデータのインポートがキャンセルされました。");
            setGpxFileLoaded(false);
            setIsGPXLoading(false); // キャンセル時もローディング終了
        }
    }, [
        aidTemplates, 
        calculateDistance, 
        generateStorageKey, 
        loadManualPoints, 
        setAppliedManualPoints, 
        setDraftManualPoints, 
        setGpxFileLoaded, 
        setGpxFileName, 
        setIsGPXLoading, 
        setManualPoints, 
        setPointsData, 
        setSimulationResult, 
        setTableData
    ]);//R1.1.4 依存配列にgpxFileLoaded, handleApplyManualPointsを追加 

    const handleStartTimeChange = useCallback((event) => {
        setStartTime(event.target.value);
    }, []);

    // ★ 追加: FINISH時間変更ハンドラ ★
    const handleFinishTimeChange = useCallback((e) => {
        setFinishTime(e.target.value);
    }, []);

    const handleItraIndexChange = useCallback((event) => {
        const value = event.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        if (numericValue === '' || (parseInt(numericValue, 10) >= 0 && parseInt(numericValue, 10) <= 1000)) {
            setItraIndex(numericValue);
        }
    }, [setItraIndex]);

    const handleDraftManualPointChange = useCallback((index, field, value) => {
        setDraftManualPoints(prevPoints => {
            const updatedPoints = [...prevPoints];
            updatedPoints[index] = { ...updatedPoints[index], [field]: value };
            return updatedPoints;
        });
    }, []);

    const addManualPoint = useCallback(() => {
        setDraftManualPoints(prevPoints => [...prevPoints, { id: uuidv4(), distance: '', type: '', name: '', restTime: '' }]);
    }, []);

    const removeManualPoint = useCallback((id) => {
        setDraftManualPoints(prevPoints => prevPoints.filter(point => point.id !== id));
    }, []);

    // ★ 新しい行を追加するハンドラー関数 ★
    const handleAddManualPointAt = useCallback((index) => {
        setDraftManualPoints(prevPoints => {
            const newPoints = [...prevPoints];
            newPoints.splice(index + 1, 0, { id: uuidv4(), distance: '', type: '', name: '', restTime: '' });
            return newPoints;
        });
    }, []);


    //applyManualPointsToPointsData
    // ✅ ユーザーが入力した エイド情報 (currentManualPoints) を pointsData に追加 する
    // ✅ 「距離」に基づいて、エイド情報を適切なポイントに適用 する
    // ✅ START (スタート地点) と FINISH (ゴール地点) を設定 する
    // ✅ リザルトテーブルでエイド情報が正しく表示できるようにする
    const applyManualPointsToPointsData = useCallback((currentPointsData, currentManualPoints) => {

        //currentPointsData のコピー (newPointsData) を作成し、元のデータを変更しないようにする。
        const newPointsData = currentPointsData.map(point => ({ ...point }));

        //currentManualPoints の各エイド情報を 1つずつ処理
        //  ✅ distance を 数値 (float) に変換 し、「エイドの距離」を取得
        //  ✅ distance が 数値でない場合 (エラー) はスキップ
        currentManualPoints.forEach(manualPoint => {
            const distance = parseFloat(manualPoint.distance);
            if (!isNaN(distance)) {
                //✅ newPointsData の中から 「エイドの距離に最も近いポイント」 を探す
                //✅ minDifference を使い、距離の差が最も小さい (closestIndex) を見つける 
                //✅ もし複数候補がある場合、より「先の距離」のポイントを選択する
                let closestIndex = -1;
                let minDifference = Infinity;

                newPointsData.forEach((point, index) => {
                    const difference = Math.abs(point.cumulative_distance - distance);
                    if (difference < minDifference) {
                        minDifference = difference;
                        closestIndex = index;
                    } else if (difference === minDifference && point.cumulative_distance > distance) {
                        closestIndex = index;
                    }
                });

                //✅ closestIndex にエイド情報を設定する 
                //✅ 区分 と 区分名称 にエイド名を適用 
                //✅ restTime と gateTime に休憩時間と関門時間を適用
                //✅ リザルトテーブルに正しく反映される
                if (closestIndex !== -1) {
                    newPointsData[closestIndex].区分 = manualPoint.type;
                    newPointsData[closestIndex].区分名称 = manualPoint.name;
                    newPointsData[closestIndex].manual = true;
                    newPointsData[closestIndex].restTime = manualPoint.restTime; // ★ restTime をコピー ★
                    newPointsData[closestIndex].gateTime = manualPoint.gateTime; // ★ gateTime をコピー ★
                }
            }
        });

        //✅ 最初のポイントを START (スタート地点) にする
        //✅ 最後のポイントを FINISH (ゴール地点) にする
        if (newPointsData.length > 0) {
            newPointsData[0].区分 = 'START';
            if (newPointsData.length > 1) {
                newPointsData[newPointsData.length - 1].区分 = 'FINISH';
            }
        }

        //✅ 更新された pointsData を返し、次の処理 (handleSimulate) で使用できるようにする！
        return newPointsData;
    }, []);

    const handleApplyManualPoints = useCallback(() => {
     if (!gpxFileName) {
      alert("GPXファイルが読み込まれていません。");
      return;
     }

     saveManualPoints(gpxFileName, draftManualPoints);
     setManualPoints(draftManualPoints.map(p => ({ ...p })));
     setAppliedManualPoints(draftManualPoints.map(p => ({ ...p })));
     setManualPointsApplied(true);
     setPointsData(prevPointsData => applyManualPointsToPointsData(prevPointsData, draftManualPoints));

    }, [gpxFileName, draftManualPoints, saveManualPoints, applyManualPointsToPointsData]);

    // エイド情報のクリア機能
    const handleClearManualPoints = useCallback(() => {
        if (!gpxFileLoaded) {
            alert("GPXファイルが読み込まれていません。");
            return;
        }

        const storageKey = `${gpxFileName}_manual_points_v2`;

        // localStorage から該当レースの保存データを削除
        localStorage.removeItem(storageKey);

        // React state も初期化
        setManualPoints([]);
        setDraftManualPoints([]);
        setAppliedManualPoints([]);
        setManualPointsApplied(false);

        // ポイントデータも初期状態に戻す
        setPointsData(prev => applyManualPointsToPointsData(prev, []));

        alert("このレースの保存データを削除しました。再度レースを選択するとエイド情報が表示されます。");
    }, [gpxFileLoaded, gpxFileName, applyManualPointsToPointsData]);

    // R2.4.2 confirm 付きの “外側の” ラッパー関数
    const handleClearManualPointsWithConfirm = useCallback(() => {
        if (!window.confirm("保存したこのレースのエイド情報をすべて削除します。よろしいですか？")) {
            return;
        }
        handleClearManualPoints();
    }, [handleClearManualPoints]);
    
    const updatedPointsDataMemo = useMemo(() => {
        return pointsData.map(point => ({ ...point }));
    }, [pointsData,draftManualPoints]);

    useEffect(() => {
        // GPXデータが読み込まれた直後、または pointsData が空になった場合に初期化処理を行う
        if (gpxFileLoaded && pointsData.length > 0 && !manualPointsApplied) {
            const initialPointsData = pointsData.map(point => ({ ...point }));
            if (initialPointsData.length > 0) {
                initialPointsData[0].区分 = 'START';
                if (initialPointsData.length > 1) {
                    initialPointsData[initialPointsData.length - 1].区分 = 'FINISH';
                }
                if (!isEqual(previousPointsDataRef.current, initialPointsData)) {
                    setPointsData(initialPointsData);
                    previousPointsDataRef.current = initialPointsData;
                }
            }
        } else if (pointsData.length === 0 && previousPointsDataRef.current?.length > 0) {
            setPointsData([]);
            previousPointsDataRef.current = null;
        }
    }, [gpxFileLoaded, pointsData, manualPointsApplied,isEqual]);

    
    // R2.4.0 START
    // 🌄 トレイルランニング向けペース補正パラメータ
    // R1.4.0 の構造を維持しつつ、トレイルの実走感に合わせて最適化したバージョン
    const paceModelParams = {
        // 🟧 上り補正（トレイルはロードより大幅に遅くなる）
        uphill: {
            coefficient: 0.032,   // 上りの基本遅延係数（0.026→0.032）
                                  // → 5〜15% の上りが現実より速く出る問題を解消
                                  // → トレイルの“走れない上り”を強めに反映
            exponent: 1.55,       // 非線形性（1.6→1.55）
                                  // → 勾配が上がるほど遅くなるが、暴れすぎないように調整
            maxFactor: 3.8        // 上り補正の上限（3.5→3.8）
                                  // → 20〜30% の“完全に歩き”を自然に表現
        },
        // 🟦 下り補正（トレイルは基本的に減速する）
        downhill: {
            threshold: -3,        // -3% より急な下りから補正開始（ロードは -5%）
                                  // → トレイルは -3% でも挙動が変わるため
            coefficient: 0.018,   // 下りの遅延係数（0.0065→0.018）
                                  // → 下りの“怖さ”を反映し、走れないレースで速く出る問題を解消
            exponent: 1.10        // 非線形性（1.05→1.10）
                                  // → 急下りでの減速を少し強める
        },
        // 🏔️ 高所補正（上り×高所の過剰遅延を防ぐ）
        altitude: {
            threshold: 1500,      // 高所補正開始（1400→1500）
                                  // → トレイルでは1500m前後から効き始めるのが自然
            rate: 1 / 2600        // 高所遅延の傾き（1/2200→1/2600）
                                  // → 上り補正が強化されたため、高所は少し弱めに調整
        },
        // 🔒 補正倍率の上下限（暴走防止）
        limits: {
            min: 0.92,            // 最速補正（0.90→0.92）
                                  // → トレイルでは下りの加速は小さめに抑える
            max: 3.2              // 最遅補正（3.0→3.2）
                                  // → 上り補正強化に合わせて上限も調整
        }
    };
    // R2.4.0 END

    // R1.4.3 START
    /**
     * 勾配・標高に基づくペース補正倍率を計算する関数（R1.4.3 安定版）
     *
     * - 上り：勾配が大きいほど非線形に遅くなる（最大3.5倍まで）
     * - 下り：-5%までは加速、それ以上は指数関数的に減速（連続的補正）
     * - 高所：標高1400mを超えると酸素の薄さにより直線的に遅くなる
     * - 最終的な補正倍率は上下限（min/max）でクリップされる
     *
     * @param {number} gradient 区間の勾配（%）例：+10（上り10%）、-8（下り8%）
     * @param {number} elevation 区間の標高（m）例：1800
     * @returns {number} ペースに乗算する補正倍率（例：1.25 → 25%遅く）
     *
     * @example
     * // 10%上り、標高1800m → 約1.8倍遅く + 高所補正
     * getGradientBasedMultiplier(10, 1800); // → 1.8〜2.0程度
     *
     * // -8%下り、標高1000m → やや加速
     * getGradientBasedMultiplier(-8, 1000); // → 0.95〜1.0程度
     *
     * // 平坦、標高1400m以下 → 補正なし
     * getGradientBasedMultiplier(0, 1200); // → 1.0
     */
    const getGradientBasedMultiplier = useCallback(
    (gradient, elevation) => {
        const { uphill, downhill, altitude, limits } = paceModelParams;

        // 🟧 上り勾配（+%）を抽出（負の値は0に）
        const gUp = Math.max(0, gradient);

        // 🟦 下り勾配（-%）を抽出（正の値は0に）
        const gDown = Math.max(0, -gradient);

        // 🟧 上り補正：非線形に遅くなる（例：10%上り → 約1.8倍遅く）
        const uphillFactor = Math.min(
        uphill.maxFactor,
        1 + uphill.coefficient * Math.pow(gUp, uphill.exponent)
        );

        // 🟦 下り補正：-5%を超える下りに対して指数関数的に補正（連続的）
        const downhillFactor = (() => {
        if (gradient >= downhill.threshold) return 1; // -5%以上の下りでなければ補正なし

        const steepness = Math.abs(gradient);
        const excess = steepness - Math.abs(downhill.threshold); // -5%を超えた分だけ補正対象

        const penalty = downhill.coefficient * Math.pow(excess, downhill.exponent);
        return 1 + penalty; // 例：-10% → 1.05、-20% → 1.15 など
        })();

        // 🏔️ 高所補正：標高1400m超から直線的に遅くなる（例：2000m → +0.27）
        const altitudePenalty = elevation > altitude.threshold
        ? (elevation - altitude.threshold) * altitude.rate
        : 0;

        // 📊 補正倍率の合成（上り×下り）＋ 高所分を加算
        const modifier = uphillFactor * downhillFactor + altitudePenalty;

        // 🔒 上下限にクリップ（例：min=0.90, max=3.0）
        return Math.max(limits.min, Math.min(limits.max, modifier));
    },
    []
    );

    /**
     * ITRAパフォーマンスインデックスと距離・時間に基づいて
     * ペースに対する疲労補正を計算する関数（R1.4.3 安定版）
     *
     * - 30km以降に距離に応じた失速を段階的に加算
     * - 経過時間に応じた時間ベースの失速も併用
     * - ITRA指数が高いほど疲労の出方が遅く、補正も軽くなる
     * - 距離補正と時間補正は融合係数で合成される
     */
    const calculatePaceWithITRA = useCallback((
    basePaceInSecondsPerKm,
    itraIndexValue,
    currentDistanceInKm,
    totalDistanceInKm,
    elapsedTimeInMs,
    totalElevationGainInMeters // R1.4.4 ★ 追加した引数 ★
    ) => {
    // R2.1.0 START
    let modifiedPace = basePaceInSecondsPerKm;
    const pi = parseInt(itraIndexValue, 10) || 400;

    // 🧠 ITRA指数に応じた最大失速率を線形補完で算出
    // 900以上で5%(0.05)、300以下で70%(0.70)とし、その間を直線的につなぐ
    let maxPenalty;
    if (pi >= 900) {
        maxPenalty = 0.05;
    } else if (pi <= 300) {
        maxPenalty = 0.70;
    } else {
        // 900から300の範囲（600間隔）で、失速率を0.05から0.70まで滑らかに変化させる
        const ratio = (900 - pi) / 600;
        maxPenalty = 0.05 + (ratio * (0.70 - 0.05));
    }
    // R2.1.0 END

    // ⛰️ **R1.4.4: 総獲得標高に応じたmaxPenaltyの増幅**
    // 経験則に基づく閾値と増幅率。データに合わせて調整してください。
    if (totalElevationGainInMeters > 5000) { // 5000mを超えたら
        maxPenalty *= 1.10; // maxPenaltyを10%増幅
    }
    if (totalElevationGainInMeters > 6000) { // さらに6000mを超えたら
        maxPenalty *= 1.05; // さらに5%増幅 (合計で約15.5%増)
    }
    // このロジックは、例えばUTMF (6942m) のようなレースでmaxPenaltyがより大きくなるように働きます。

    // 📏 距離ベースの失速（30km以降に段階的に加算）
    let latePenalty = 0;
    if (currentDistanceInKm > 30 && totalDistanceInKm > 30) {
        const distanceAfterThreshold = currentDistanceInKm - 30;
        const remainingDistanceAfterThreshold = totalDistanceInKm - 30;
        const penaltyFactor = Math.min(1, distanceAfterThreshold / remainingDistanceAfterThreshold);
        latePenalty = maxPenalty * penaltyFactor;
    }

    // ⏱ 時間ベースの失速（ITRA依存で開始を遅らせる）
    const fatigueDelayHours = Math.min(3, Math.max(0, (itraIndexValue - 400) / 100)); // 例：ITRA 500 → +1時間遅らせる
    const timePenaltyStart = 3 + fatigueDelayHours; // 3時間 + 遅延
    const maxTimePenalty = 0.20 - Math.min(0.10, (itraIndexValue - 400) * 0.00025); // 高ITRAほど最大補正が小さい

    const elapsedHours = elapsedTimeInMs / (1000 * 60 * 60);
    let timePenalty = 0;
    if (elapsedHours > timePenaltyStart) {
        const timeOver = elapsedHours - timePenaltyStart;
        timePenalty = Math.min(maxTimePenalty, timeOver / 10); // 10時間で最大補正に達する
    }

    // 🔗 距離補正と時間補正を融合（融合係数で抑制）
    const fusionFactor = 0.8;
    const totalPenalty = 1 + (latePenalty + timePenalty) * fusionFactor;
    modifiedPace *= totalPenalty;

    return modifiedPace;
    }, []);
    // R1.4.3 END

    // R1.4.4 START
    /**
     * 累積標高に応じた疲労係数（ペース補正倍率）を計算する関数
     *
     * - 4000m以下は補正なし（1.0を返す）
     * - 4000mを超えると、最大3000m分まで段階的に増幅
     * - 最大で +15% まで補正される（1.15倍）
     * - 高標高レースにおける疲労の蓄積をシミュレートする目的
     *
     * @param totalElevationGain 累積標高（登り）総量 [単位: メートル]
     * @returns 疲労によるペース補正係数 [例: 1.12 → 12%増し]
     */
    function getFatigueFactor(totalElevationGain) {
    const elevationThreshold = 4000; // 増幅開始の標高（m）
    const maxGain = 3000;            // 増幅対象となる標高の範囲（m）
    const maxBoost = 0.15;           // 最大で15%まで補正倍率を増加

    // 標高が閾値未満なら疲労補正なし（1.0倍）
    if (totalElevationGain < elevationThreshold) return 1;

    // 閾値を超えた部分を抽出（excessが増幅対象）
    const excess = totalElevationGain - elevationThreshold;

    // 増幅範囲に対して正規化（最大1.0まで）
    const normalized = Math.min(1, excess / maxGain);

    // 疲労係数を補正（最大で1.15倍）
    const boost = 1 + normalized * maxBoost;

    return boost;
    }
    // R1.4.4 END

    // ★★★ R2.2.5: finalPace を受け取るように修正 ★★★
    const handleSimulate = useCallback(async (pace) => {

    // ★★★ R2.2.5: pace が未設定ならエラーに変更 ★★★
    if (!pace) {
        alert("基準ペースが設定されていません。");
        return;
    }

    // ★ 手動エイドポイントを GPXデータに反映
    const pointsWithManual = applyManualPointsToPointsData(updatedPointsDataMemo, draftManualPoints);

    // ★ 必須チェック
    if (!startTime || pointsWithManual.length === 0) {
        alert("START時間、GPXデータのいずれかが入力されていません。");
        return;
    }

    // ★ スタート時間をミリ秒化
    const [startHours, startMinutes] = startTime.split(':').map(Number);
    const start = new Date();
    start.setHours(startHours, startMinutes, 0, 0);
    const startTimeInMilliseconds = start.getTime();

    // ★★★ R2.2.5: initialPace を使わず、引数 pace を使うように修正 ★★★
    const [paceMinutes, paceSeconds] = pace.split(':').map(Number);
    const basePaceInSecondsPerKm = paceMinutes * 60 + paceSeconds;

    // ★ 累積標高（登りのみ）
    const totalElevationGain = pointsWithManual.reduce((sum, point, i) => {
        if (i === 0) return sum;
        const gain = point.elevation - pointsWithManual[i - 1].elevation;
        return gain > 0 ? sum + gain : sum;
    }, 0);

    const totalDistance =
        pointsWithManual.length > 0
        ? pointsWithManual[pointsWithManual.length - 1].cumulative_distance
        : 0;

    // ---------- Pass 1: 到着時刻を付与 ----------
    let elapsedTimeFromStart = 0;
    const pointsWithArrival = pointsWithManual.map((point, i) => {
        const newPoint = { ...point };

        // ★★★ R2.2.5: finalPace をベースに ITRA 補正を計算 ★★★
        let currentPaceInSecondsPerKm = calculatePaceWithITRA(
        basePaceInSecondsPerKm,
        parseInt(itraIndex, 10),
        newPoint.cumulative_distance,
        totalDistance,
        totalElevationGain
        );

        const gradient = newPoint.section_gradient || 0;
        const elevation = newPoint.elevation || 0;
        const fatigueFactor = getFatigueFactor(totalElevationGain);
        const multiplier = getGradientBasedMultiplier(gradient, elevation) * fatigueFactor;
        currentPaceInSecondsPerKm *= multiplier;

        // 区間移動時間
        const travelTimeInSeconds = newPoint.section_distance * currentPaceInSecondsPerKm;

        if (i > 0) {
        elapsedTimeFromStart += travelTimeInSeconds * 1000;
        }

        const arrivalTime = new Date(startTimeInMilliseconds + elapsedTimeFromStart);
        newPoint.arrivalTimestamp = arrivalTime.getTime();

        if (i > 0 && newPoint.manual && newPoint.restTime) {
        elapsedTimeFromStart += parseInt(newPoint.restTime, 10) * 60 * 1000;
        }

        return newPoint;
    });

    // ---------- Pass 2: 天気付与 ----------
    const enrichedPoints = await enrichTableDataWithWeather(pointsWithArrival);
    setPointsData(enrichedPoints);

    // ---------- Pass 3: 表示用データ生成 ----------
    const newResults = [];
    const newTableData = [];
    const newCumulativeDistances = [];
    let previousPointWithNonEmptyKubun = null;
    let firstKmArrivalTimeTemp = null;
    let reachedFirstKm = false;

    for (let i = 0; i < enrichedPoints.length; i++) {
        const currentPoint = enrichedPoints[i];
        const arrivalTimeFormatted = new Date(currentPoint.arrivalTimestamp).toLocaleTimeString('ja-JP', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
        });

        let sectionDistanceForTable = '0.00';
        if (currentPoint.区分 !== '' && previousPointWithNonEmptyKubun) {
        sectionDistanceForTable = (currentPoint.cumulative_distance - previousPointWithNonEmptyKubun.cumulative_distance).toFixed(1);
        } else if (i === 0) {
        sectionDistanceForTable = '0.0';
        }

        let gateTimeForTable = currentPoint.gateTime;
        if (currentPoint.区分 === 'FINISH' && finishTime && finishTime !== '') {
        gateTimeForTable = finishTime;
        }

        newResults.push({
        name: currentPoint.name,
        arrivalTime: arrivalTimeFormatted,
        cumulativeDistance: currentPoint.cumulative_distance,
        elevation: currentPoint.elevation,
        section_gradient: currentPoint.section_gradient,
        区分: currentPoint.区分,
        区分名称: currentPoint.区分名称,
        weatherIconUrl: currentPoint.weatherIconUrl,
        weatherTemp: currentPoint.weatherTemp,
        restTime: currentPoint.restTime,
        elapsedTime: currentPoint.arrivalTimestamp - startTimeInMilliseconds,
        gateTime: gateTimeForTable,
        });

        newCumulativeDistances.push(currentPoint.cumulative_distance);

        const restTimeStr = currentPoint.restTime ? `（${currentPoint.restTime}分）` : '';

        newTableData.push({
        区分: currentPoint.区分,
        区分名称: currentPoint.区分名称,
        累積距離: currentPoint.cumulative_distance.toFixed(1),
        区間距離: sectionDistanceForTable,
        標高: currentPoint.elevation,
        weatherIconUrl: currentPoint.weatherIconUrl,
        weatherTemp: currentPoint.weatherTemp,
        到着時刻: `${arrivalTimeFormatted.slice(0, 5)}${restTimeStr}`,
        休憩時間: currentPoint.restTime,
        経過時間: formatTime(currentPoint.arrivalTimestamp - startTimeInMilliseconds),
        関門時間: gateTimeForTable,
        });

        if (currentPoint.区分 !== '') {
        previousPointWithNonEmptyKubun = currentPoint;
        }
        if (!reachedFirstKm && currentPoint.cumulative_distance >= 1) {
        firstKmArrivalTimeTemp = arrivalTimeFormatted;
        reachedFirstKm = true;
        }
    }

    // ---------- 状態更新 ----------
    setManualPoints(draftManualPoints.map(p => ({ ...p })));
    setAppliedManualPoints(draftManualPoints.map(p => ({ ...p })));
    setManualPointsApplied(true);
    setIsApplyButtonFlashing(false);

    setFirstKmArrivalTime(firstKmArrivalTimeTemp);
    setCumulativeDistancesForGraph(newCumulativeDistances);
    setSimulationResult(newResults);
    setTableData(newTableData.filter(item => item.区分 !== ''));

    }, [
    getGradientBasedMultiplier,
    draftManualPoints,
    finishTime,
    startTime,
    updatedPointsDataMemo,
    manualPoints,
    setCumulativeDistancesForGraph,
    setSimulationResult,
    setTableData,
    applyManualPointsToPointsData,
    itraIndex,
    calculatePaceWithITRA,
    setIsApplyButtonFlashing
    ]);
    // R2.2.5

    const pointsDataMemo = useMemo(() => pointsData, [pointsData]);
    const simulationResultMemo = useMemo(() => simulationResult, [simulationResult]);

    const cumulativeDistancesForGraphMemo = useMemo(() => cumulativeDistancesForGraph, [cumulativeDistancesForGraph]);

    const [openAidIndex, setOpenAidIndex] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navigate = useNavigate();

    return (
        <div className="App">
          {/* 🏆 SEO最適化: 大会名とキーワードをブラウザタイトルに反映 */}
            <Helmet>
                <title>
                    Trail Run Simulator｜トレランのエイド計画・関門タイム計算アプリ
                </title>
                <meta
                    name="description"
                    content="GPXデータとエイド情報からトレイルランニングの予想タイムを自動計算。各エイドの関門時刻や休憩時間を設定し、完走計画表・ペース配分表を簡単に作れるシミュレーターです。"
                />
                <meta name="robots" content="index, follow" />
                {/* ✅ 構造化データを追加 */}
                <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Trail Run Simulator",
                        "url": "https://trailrunsim.com/",
                        "description": "トレイルランナー向けの完走支援・ペース配分ツール。GPXデータをもとに、エイドごとの関門到着予測と補給・休憩戦略を立てられるWebアプリです。",
                        "publisher": {
                          "@type": "Person"
                        }
                      }
                    `}
                </script>
            </Helmet>            
            <main>
                <div className="p-4 mb-6 bg-white rounded-xl shadow-md max-w-3xl mx-auto"　style={{ textAlign: 'left' }}>
                <button 
                onClick={() => setIsModalOpen(true)}
                style={{
                    backgroundColor: '#ff6600',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '6px 14px',
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '5px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
                >
                <span>🆙</span> 更新履歴
                </button>
                    <h2 className="text-xl font-semibold mb-2">トレイルランニングシミュレータへようこそ</h2>
                    <p className="mb-2">
                        このアプリは、GPXデータやエイド情報をもとに、トレイルランニングの
                        予測タイムやエイドごとの通過予定時刻を自動でシミュレーションできる
                        ツールです。
                        「制限時間に間に合うか不安…」「自分のペース配分がわからない」
                        という初心者・中級者の方から、FUJI100、彩の国、信越五岳、ハセツネ
                        などのウルトラトレイルに挑む上級者まで幅広く対応。無理のない完走計画表づくりをサポートします。
                    </p>
                {/* R3.0.9 ★ 今月以降の大会リストを自動生成するロジック（国内・海外分離版） ★ */}
                <h3 style={{ marginTop: '2rem', marginBottom: '0.6rem' }}>
                シミュレーション可能な今後のレース
                </h3>

                {/* 国内セクション */}
                <div style={{ fontWeight: 600, marginTop: '1rem', marginBottom: '0.4rem' }}>
                〇国内
                </div>
                <ul style={{ lineHeight: 1.7, marginBottom: '1.2rem' }}>
                {domesticGroupedRaces.map(r => (
                    <li key={r.title}>
                    {formatDate(r.date)} {r.title}
                    {r.distances.length > 0 && `（${r.distances.join("・")}）`}
                    </li>
                ))}
                </ul>

                {/* 海外セクション */}
                <div style={{ fontWeight: 600, marginTop: '1rem', marginBottom: '0.4rem' }}>
                〇海外
                </div>
                <ul style={{ lineHeight: 1.7 }}>
                {overseasGroupedRaces.map(r => (
                    <li key={r.title}>
                    {formatDate(r.date)} {r.title}
                    {r.distances.length > 0 && `（${r.distances.join("・")}）`}
                    </li>
                ))}
                </ul>
                {/* R3.0.9 ★ 今月以降の大会リストを自動生成するロジック（国内・海外分離版） ★ */}

                    <p style={{ lineHeight: 1.8, color: "#555", marginBottom: "2rem" }}>
                    レースは ITRA（国際トレイルランニング協会）の基準に基づき、XXS〜XXL の7段階で分類しています。  
                    レースを選択すると、GPX・エイド情報・スタート時間・制限時間が自動でセットされ、あとは走力やペースを入力するだけで、通過予測や関門到着可否をグラフと表、地図で確認できます。
                    初心者から上級者まで、トレイルランニングをもっと安心に、もっと楽しくするためのシミュレーションツールです。
                    </p>

                    <Link
                    to="/how-to-use"
                    style={{
                        display: "inline-block",
                        backgroundColor: "#2c7be5",
                        color: "#fff",
                        padding: "10px 18px",
                        borderRadius: "8px",
                        fontWeight: "bold",
                        marginBottom: "1.6rem",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        textDecoration: "none"
                    }}
                    onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                    onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
                    >
                    ▶ 使い方ガイドを見る
                    </Link>


                    {/* ✅ 広告をここに挿入 */}
                    {/* DEL   }
                    <AdSenseBlock adSlot={AD_SLOTS.TOP} />
                    {   DEL */}
                </div>
                <section className="max-w-3xl mx-auto bg-white shadow-md rounded-xl p-4 mt-6 mb-8">

                  <GPSImportWithPresets 
                    onDataImport={handleGPSDataImport} 
                    onFileSelected={handleFileSelected} 
                  />

                  {isGPXLoading && (
                    <div className="loading-container mt-4 text-center">
                      <PuffLoader color="#00BFFF" height={60} width={60} />
                      <p className="mt-2 text-gray-600 text-sm">GPXファイルを読み込み中...</p>
                    </div>
                  )}
                </section>

                <div  className="aid-container" id="aid-info-area">
                    <h2 style={{
                        fontSize: '1.5rem',
                        fontWeight: 800,
                        color: '#4a5568',
                        textAlign: 'center',
                        marginBottom: '12px'
                        }}>
                        エイド情報
                    <Tooltip
                        text={
                            "レースを選択すると、エイドの基本情報（名称・距離・関門時間）は自動でセットされます。\n" +
                            "必要に応じて、各エイドでの休憩時間を自分の戦略に合わせて入力してください。\n" +
                            "新しいエイドや立ち寄りポイントを追加したい場合は、行の先頭にある＋ボタンで追加できます。\n" +
                            "エイド以外にも山頂（peak）や峠なども登録しています。不要な場合は、削除ボタンで削除してください。"
                        }
                    />
                    </h2>
                    {/*R1.3.0 START*/}
                    {isMobile
                    ? draftManualPoints.map((point, index) => (
                        // ✅ モバイル用：アコーディオンレイアウト
                        <div key={point.id} className="accordion-section">
                            <button 
                                onClick={() => setOpenAidIndex(openAidIndex === index ? null : index)}
                                style={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '16.0px',
                                    padding: '8px 6px'
                                }}
                            >
                                {point.type && point.name
                                    ? `${point.type} ${point.name}（${Number(point.distance || 0).toFixed(1)}km）`
                                    : `地点 ${index + 1}`}
                            </button>
                            {openAidIndex === index && (
                            <div className="accordion-content">
                                {/* 入力欄群（距離・区分など）をここに挿入 */}
                                <div 
                                key={point.id} 
                                className="manual-point-row"  // ← この行を追加

                                >
                                {/* ★ 追加ボタン ★ */}
                                <button type="button"  className="add-btn" onClick={() => handleAddManualPointAt(index)} style={{ marginLeft: '5px' }}>＋</button>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>
                                        距離 (km):
                                    </label>
                                    <input
                                        type="number"
                                        value={point.distance}
                                        onChange={(e) => handleDraftManualPointChange(index, 'distance', e.target.value)}
                                        style={{ width: '75px' }}
                                        tabIndex={index + 1} // ★ 距離の tabindex ★
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>
                                        区分:
                                    </label>
                                    <input
                                        type="text"
                                        value={point.type}
                                        onChange={(e) => handleDraftManualPointChange(index, 'type', e.target.value)}
                                        style={{ width: '60px' }}
                                        tabIndex={(draftManualPoints.length * 1) + index + 1} // ★ 区分 の tabindex ★
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>
                                        区分名:
                                    </label>
                                    <input
                                        type="text"
                                        value={point.name}
                                        onChange={(e) => handleDraftManualPointChange(index, 'name', e.target.value)}
                                        style={{ width: '150px' }}
                                        tabIndex={(draftManualPoints.length * 2) + index + 1} // ★ 区分名 の tabindex ★
                                    />
                                </div>
                                {/* ★ R2.2.1 変更箇所：休憩入力を5分刻み(60分まで)＋長時間休憩のセレクトボックス化（モバイル） ★ */}
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>休憩:</label>
                                    <select
                                        value={point.restTime || 0}
                                        onChange={(e) => handleDraftManualPointChange(index, 'restTime', Number(e.target.value))}
                                        style={{ 
                                            width: '105px', // 選択肢の文字幅に合わせて少し広げました
                                            fontSize: '14px',
                                            padding: '2px',
                                            borderRadius: '4px'
                                        }}
                                        tabIndex={(draftManualPoints.length * 3) + index + 1} // ★ 休憩時間 の tabindex ★
                                    >
                                        {[
                                            ...Array.from({ length: 13 }, (_, i) => i * 5), // 0, 5, 10 ... 60
                                            90, 120, 150, 180                              // 60分以降
                                        ].map((min) => (
                                            <option key={min} value={min}>
                                                {min === 0 ? 'なし' :
                                                min === 90 ? '90分 (1.5h)' :
                                                min === 120 ? '120分 (2h)' :
                                                min === 150 ? '150分 (2.5h)' :
                                                min === 180 ? '180分 (3h)' : `${min} 分`}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* ★ R2.2.1 変更箇所ここまで ★ */}
                                {/* ★ 関門時間入力欄 ★ */}
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>関門時刻:</label>
                                    <input
                                        type="time" // または type="text"
                                        value={point.gateTime}
                                        onChange={(e) => handleDraftManualPointChange(index, 'gateTime', e.target.value)}
                                        style={{ width: '110px' }}
                                        tabIndex={(draftManualPoints.length * 4) + index + 1} // 必要に応じて調整
                                    />
                                </div>
                                {draftManualPoints.length > 1 && (
                                    <button type="button" className="delete-btn" onClick={() => removeManualPoint(point.id)} style={{ marginLeft: '5px' }}>削除</button>
                                )}
                            </div>
                        </div>

                        )}
                    </div>
                    ))
                    : draftManualPoints.map((point, index) => (
                        // ✅ デスクトップ用：フラットな行表示（現状の layout）
                        <div key={point.id} className="manual-point-row">
                            {/* 現在の入力UIをそのまま */}

                                {/* ★ 追加ボタン ★ */}
                                <button type="button"  className="add-btn" onClick={() => handleAddManualPointAt(index)} style={{ marginLeft: '5px' }}>＋</button>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>
                                        距離 (km):
                                    </label>
                                    <input
                                        type="number"
                                        value={point.distance}
                                        onChange={(e) => handleDraftManualPointChange(index, 'distance', e.target.value)}
                                        style={{ width: '60px' }}
                                        tabIndex={index + 1} // ★ 距離の tabindex ★
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>
                                        区分:
                                    </label>
                                    <input
                                        type="text"
                                        value={point.type}
                                        onChange={(e) => handleDraftManualPointChange(index, 'type', e.target.value)}
                                        style={{ width: '60px' }}
                                        tabIndex={(draftManualPoints.length * 1) + index + 1} // ★ 区分 の tabindex ★
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>
                                        区分名:
                                    </label>
                                    <input
                                        type="text"
                                        value={point.name}
                                        onChange={(e) => handleDraftManualPointChange(index, 'name', e.target.value)}
                                        style={{ width: '150px' }}
                                        tabIndex={(draftManualPoints.length * 2) + index + 1} // ★ 区分名 の tabindex ★
                                    />
                                </div>
                                {/* ★ R2.2.1 変更箇所：休憩入力を5分刻み(60分まで)＋長時間休憩のセレクトボックス化（デスクトップ） ★ */}
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>休憩:</label>
                                    <select
                                        value={point.restTime || 0}
                                        onChange={(e) => handleDraftManualPointChange(index, 'restTime', Number(e.target.value))}
                                        style={{ 
                                            width: '105px', // 選択肢の文字幅に合わせて少し広げました
                                            fontSize: '14px',
                                            padding: '2px',
                                            borderRadius: '4px'
                                        }}
                                        tabIndex={(draftManualPoints.length * 3) + index + 1} // ★ 休憩時間 の tabindex ★
                                    >
                                        {[
                                            ...Array.from({ length: 13 }, (_, i) => i * 5).map(min => min), // 0, 5, 10 ... 60
                                            90, 120, 150, 180                                              // 60分以降
                                        ].map((min) => (
                                            <option key={min} value={min}>
                                                {min === 0 ? 'なし' :
                                                min === 90 ? '90分 (1.5h)' :
                                                min === 120 ? '120分 (2h)' :
                                                min === 150 ? '150分 (2.5h)' :
                                                min === 180 ? '180分 (3h)' : `${min} 分`}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* ★ R2.2.1 変更箇所ここまで ★ */}
                                {/* ★ 関門時間入力欄 ★ */}
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                                    <label style={{ marginRight: '5px' }}>関門時刻:</label>
                                    <input
                                        type="time" // または type="text"
                                        value={point.gateTime}
                                        onChange={(e) => handleDraftManualPointChange(index, 'gateTime', e.target.value)}
                                        style={{ width: '90px' }}
                                        tabIndex={(draftManualPoints.length * 4) + index + 1} // 必要に応じて調整
                                    />
                                </div>
                                {draftManualPoints.length > 1 && (
                                    <button type="button" className="delete-btn" onClick={() => removeManualPoint(point.id)} style={{ marginLeft: '5px' }}>削除</button>
                                )}

                        </div>
                        ))}
                        {/*R2.3.0 END*/}
                        <div className="aid-card-actions">
                        <button
                            type="button"
                            className="save-aid-button"
                            onClick={handleApplyManualPoints}
                            disabled={!gpxFileLoaded}
                        >
                            エイド情報保存
                            <Tooltip text="保存すると、このレースで入力した休憩時間や区分名などが自動的に反映されます。" />
                        </button>
                        <button
                            type="button"
                            className="clear-aid-button"
                            onClick={handleClearManualPointsWithConfirm}
                            disabled={!gpxFileLoaded}
                        >
                            保存データクリア
                            <Tooltip text="保存したエイド情報をすべてクリアします。再度レースを選択するとエイド情報が表示されます。" />
                        </button>
                        </div>

                        {!gpxFileLoaded && (
                        <p className="warning-message">GPXファイルを読み込んでから適用してください。</p>
                        )}

                        {feedbackMessage && (
                        <div className="feedback-message" style={{ marginTop: '10px' }}>
                            {feedbackMessage}
                        </div>
                        )}
                    </div>
                <PaceInput
                    startTime={startTime}
                    finishTime={finishTime} // ★ 追加: finishTime を PaceInput に渡す ★
                    onStartTimeChange={handleStartTimeChange}
                    onFinishTimeChange={handleFinishTimeChange} // ★ 追加: onFinishTimeChange を PaceInput に渡す ★
                    onSimulate={handleSimulate}
                    itraIndex={itraIndex} // ★ ITRA Index を PaceInput に渡す
                    onItraIndexChange={handleItraIndexChange} // ★ ITRA Index の変更ハンドラを渡す
                    initialPace={initialPace} //R1.4.1
                    onInitialPaceChange={handleInitialPaceChange} //R1.4.1
                    gpxFileName={gpxFileName} // R1.2.2 
                />
                {simulationResult.length > 0 && (
                    <>
                        {/* ✅ ここに広告を挿入（結果のすぐ上） */}
                        <AdSenseBlock adSlot={AD_SLOTS.TOP} />  
                        
                        <TimeGraph
                            results={simulationResultMemo}
                            startTime={startTime}
                            interval={10}
                            cumulativeDistances={cumulativeDistancesForGraphMemo}
                            pointsData={pointsDataMemo}
                            appliedManualPoints={appliedManualPoints}
                            elapsedTime={simulationResultMemo.length > 0 ? simulationResultMemo[simulationResultMemo.length - 1].elapsedTime : 0} // 総経過時間を渡す
                            raceLimitTime={finishTime}   // R2.2.3 終了時刻を渡す
                            limit={selectedPreset?.limit}    // R2.2.6 制限時間を渡す
                        />
                        {/* ✅ 結果テーブルの表示 */}
                        <ResultTable data={tableData}/>

                        {/* 🗺️ ✅ R2.2.0 国土地理院地図をテーブルの後ろに配置 */}
                        {/* テーブルと同じ `tableData`（またはGPXの生軌跡データ）を渡すことで綺麗に連動します */}
                        <GsiMap 
                            data={tableData} 
                            gpxPoints={pointsDataMemo}
                            raceLimitTime={finishTime}   // R2.2.3 finishTime を渡す 
                        />

                        {/* ✅ 開発環境でのみ 3D 表示ボタンを表示 公開時には条件文削除*/} 
                        {/*process.env.NODE_ENV === "development" && (*/}
                            <button
                            onClick={() =>
                                navigate('/run3d', { 
                                state: { 
                                    gpxPoints: pointsData,
                                    aidList: pointsDataMemo.filter(p => p.区分 !== "").map(p => {
                                        // simulationResult から該当地点の arrivalTime（到着時刻）を探して紐付ける
                                        const matched = simulationResult.find(r => r.cumulativeDistance === p.cumulative_distance);
                                        return {
                                            ...p,
                                            到着時刻: matched ? matched.arrivalTime.slice(0, 5) : '',
                                            restTime: matched ? matched.restTime : p.restTime,
                                            gateTime: matched ? matched.gateTime : p.gateTime,
                                        };
                                    }), 
                                    simTotalTimeSec: simulationResultMemo.length > 0 
                                    ? simulationResultMemo[simulationResultMemo.length - 1].elapsedTime / 1000
                                    : 0,
                                    raceName: selectedPreset?.label 
                                } 
                                })
                            }
                            style={{
                                padding: "12px 20px",
                                borderRadius: "14px",
                                background: "rgba(255,255,255,0.55)",
                                backdropFilter: "blur(12px)",
                                border: "1px solid rgba(200,200,200,0.7)",
                                boxShadow: "0 6px 18px rgba(0,0,0,0.22)",
                                fontSize: "1rem",
                                fontWeight: 600,
                                color: "#222",
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = "0 8px 22px rgba(0,0,0,0.28)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.22)";
                            }}
                            >
                            🗺️ ルートを3Dで見る
                            </button>
                        {/*})}*/}
                        {/* ✅ 広告をここに挿入 */}
                        <AdSenseBlock adSlot={AD_SLOTS.TOP} />
                    </>
                )}
            </main>
          {/* 更新履歴モーダル本体 */}
          <ChangeLogModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />            
        </div>
    );
}

export default MainApp; /*R1.1.0*/